import React, { useEffect } from "react";

export default function DialogGast(props: { gastData: any; setGastData: (gastData: any | undefined) => void }) {
  const { gastData, setGastData } = props;

  useEffect(() => {
    const inner = document.querySelector("#dialogGast");
    if (inner) {
      const f = Math.min(1, (window.innerWidth - 50) / inner.clientWidth);
      (inner as any).style.transform = `scale(${f})`;
      (inner as any).style.transformOrigin = "top";
    }
  });

  function bestaetigenGastDaten() {
    var iban = $("#GastIBAN").val();
    var inhaber = $("#GastKontoInhaber").val();
    var gastName = $("#gastName").val();

    const gastData = {
      iban: iban,
      name: gastName,
      KontoInhaber: inhaber,
      gastIstJugendlich: false,
    };

    setGastData(gastData);
  }

  function abort() {
    setGastData(undefined);
  }

  return (
    <div id="gastDialog">
      <div style={{ padding: "10px" }} className="modal-header">
        <h1 style={{ fontSize: "1em", fontWeight: "bold" }} className="modal-title">
          Daten des Gastspielers
        </h1>
      </div>

      <div style={{ padding: "20px", display: "flex", flexDirection: "column", textAlign: "left" }}>
        <div style={{ display: "flex", flexDirection: "row", paddingTop: "10px" }}>
          Name Gasts:
          <input style={{ marginLeft: "10px" }} id="gastName" />
        </div>
        <br />
        Ich erkläre mich mit dem Einzug der Gastgebühr von meinem Konto einverstanden. <br />
        <br />
        Dabei soll folgendes Konto verwendet werden: <br />
        <br />
        {gastData.iban}
        <br />
        Kontoinhaber {gastData.KontoInhaber}
      </div>

      <div style={{ padding: "20px" }} className="modal-footer">
        <button
          type="button"
          style={{ backgroundColor: "indianred" }}
          className="btn"
          onClick={() => {
            abort();
          }}
        >
          Abbrechen
        </button>
        &nbsp; &nbsp;
        <button
          id="bestaetigenGastDaten"
          type="button"
          onClick={() => {
            bestaetigenGastDaten();
          }}
          className="btn btn-primary"
        >
          Bestätigen
        </button>
      </div>
    </div>
  );
}
